<template>

<layout>
  <template v-slot:body>
    <div class="desktop">
      <component
        :is="currentPlatformComponent"
        :id="d_id"
        :key="d_id">
      </component>
    </div>
  </template>
</layout>

</template>


<script>
import layout from '@/components/layout.vue';
import desktopSmall from '@/components/pages/desktopSmall.vue';
import desktop from '@/components/pages/desktop.vue';
import theFlow from '@/components/pages/theFlow.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Desktop',
  components: {
    layout,
    desktopSmall,
    desktop,
    theFlow,
  },
  props: {
    d_id: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      creativesDesktop: ['getDesktopCreatives'],
    }),
    currentPlatformComponent() {
      let platform = '';
      if (this.d_id) {
        for (let i = 0; i < this.creativesDesktop.length; i += 1) {
          if (this.creativesDesktop[i].id === this.d_id) {
            platform = this.creativesDesktop[i].platform;
          }
        }
      } else if (this.creativesDesktop[0]) {
        platform = this.creativesDesktop[0].platform;
      } else {
        platform = 'desktop';
      }
      return platform;
    },
  },
};
</script>

<style scoped lang='stylus'>
.desktop
  background-color white
</style>
